"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsTouchDevice = useIsTouchDevice;
const react_1 = require("react");
const is_touch_device_1 = require("../../helpers/is-touch-device");
/**
 * При монтировании проверяет, поддерживает ли устройство touch события.
 * @return True - если поддерживает, false - если нет.
 */
function useIsTouchDevice() {
    const [isTouch, setTouch] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setTouch((0, is_touch_device_1.isTouchDevice)());
    }, []);
    return isTouch;
}
//# sourceMappingURL=index.js.map